
const state = {
  isConnected: false,
  socketMessage: '',
};

const mutations = {
  socket_connect(state) {
    state.isConnected = true; // eslint-disable-line
  },

  socket_versionUpdated(state, message) {
    state.socketMessage = message; // eslint-disable-line
  },

  socket_disconnect(state) {
    state.isConnected = false; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/websocket.js